import PatientHeightInput from './PatientHeightInput';

export default PatientHeightInput;
